import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";

const _this = Vue.prototype;

// 此针对openid为字符串null的情况,删除本地openid重新获取最新的code
function initCodeApi() {
  localStorage.removeItem("openId");
  let originalUrl = window.location.href;
  // 使用indexOf方法找到参数部分的起始位置
  var index = originalUrl.indexOf("?");
  // 如果找到了参数部分，则截取URL并重新拼接
  if (index !== -1) {
    var newUrl =
      originalUrl.substring(0, index) +
      originalUrl.substring(originalUrl.indexOf("#"));
    getCodeApi(newUrl);
  } else {
    getCodeApi(originalUrl);
  }
}

// 获取url上指定的参数
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

// 获取code
function getCodeApi(origlUrl) {
  console.log(_this);
  const redUrl = origlUrl ? origlUrl : window.location.href;
  const urlNow = encodeURIComponent(redUrl);
  const scope = "snsapi_base"; // 静默授权 用户无感知
  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${_this.GLOBAL.appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=123#wechat_redirect`;
  window.location.href = url;
  // getOpenidApi(getUrlKey('code'))
}

// 获取openId
function getOpenidApi(code, callback) {
  console.log(_this.GLOBAL.ssoServer);
  axios
    .get(_this.GLOBAL.ssoServer + "/gzh/getOpenidByCode", {
      params: {
        code: code,
      },
    })
    .then(function (response) {
      const { data, code } = response.data;
      console.log(data, code, response);
      if (code !== "0000000") {
        Toast("请求失败请退出重新进入");
        localStorage.removeItem("openId");
        return;
      }
      localStorage.setItem("openId", data);
      callback ? callback() : "";
    })
    .catch((err) => {
      console.log(err, "openIderr");
    });
}

// 初始化
function initOpenid(callback) {
  const code = getUrlKey("code");
  if (code) {
    //拿到code， code传递给后台接口换取opend
    getOpenidApi(code, callback);
  } else {
    getCodeApi();
  }
}

export { initOpenid, getUrlKey, initCodeApi };
